import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04447670"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col grow" }
const _hoisted_2 = {
  key: 1,
  class: "flex overflow-hidden flex-col p-4 h-full bg-zinc-100 lg:p-12"
}
const _hoisted_3 = { class: "flex-none lg:mb-12" }
const _hoisted_4 = {
  key: 0,
  class: "inline-block px-2 text-white bg-teal-500"
}
const _hoisted_5 = { class: "grow shrink-0 gap-12 prose-sm lg:columns-2 lg:max-w-full lg:prose 2xl:columns-3 columns-fill-auto" }
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["innerHTML"]

import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import AppPageTitle from './AppPageTitle.vue';
import { setTitle } from '../title';
import AppLoading from './AppLoading.vue';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { Product } from '../types/Product';

interface Page {
  title: string,
  content: string,
  excerpt: string,
  image: string,
  id: number,
  slug: string,
  category: Product['category']
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const breakpoints = useBreakpoints(breakpointsTailwind);

const router = useRouter();
const route = useRoute();

const loading = ref(false);

const page = ref<Page>();
const error = ref();

watch(
  () => route.params.slug,
  (newSlug) => {
    if (newSlug) { // when redirecting to route that is NOT PAGE it will be undefined
      loading.value = true;
      axios.get(`/api/page/${newSlug}`)
        .then((response) => {
          if (!response || !response.data || !response.data.data) {
            throw new Error();
          }
          page.value = response?.data?.data;
          
          setTitle(page.value.title);
        })
        .catch(() => {
          router.push({
            name: 'NotFound',
            params: {
              pathMatch: route?.path.substring(1)
                .split('/'),
            },
            query: route?.query,
            hash: route?.hash,
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }
  },
  {
    immediate: true,
  },
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createBlock(AppLoading, { key: 0 }))
      : _createCommentVNode("", true),
    (page.value && !loading.value)
      ? (_openBlock(), _createElementBlock("article", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(AppPageTitle, {
              title: page.value.title
            }, null, 8, ["title"]),
            (page.value.category)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(page.value.category.title), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (page.value.image)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("img", {
                    class: "!mt-0",
                    src: '/storage/' + page.value.image,
                    alt: ""
                  }, null, 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true),
            (page.value.excerpt)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(page.value.excerpt), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              innerHTML: page.value.content
            }, null, 8, _hoisted_9)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})